var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A6130",
    d: "M19.643 23.397H2.705C1.218 23.397 0 22.18 0 20.692V4.402c0-1.488 1.218-2.705 2.705-2.705h16.938c1.488 0 2.706 1.217 2.706 2.705v16.29c0 1.488-1.218 2.705-2.706 2.705",
    transform: "translate(.312 .346)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8A16B",
    d: "M12.405 11.852c0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34.74 0 1.34.6 1.34 1.34M16.36 11.852c0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34.74 0 1.34.6 1.34 1.34M20.316 11.852c0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34.74 0 1.34.6 1.34 1.34M12.405 15.864c0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34.74 0 1.34.6 1.34 1.34M16.36 15.864c0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34.74 0 1.34.6 1.34 1.34M20.316 15.864c0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34.74 0 1.34.6 1.34 1.34M12.405 19.877c0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34.74 0 1.34.6 1.34 1.34M16.36 19.877c0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34.74 0 1.34.6 1.34 1.34M20.316 19.877c0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34.74 0 1.34.6 1.34 1.34M19.455 7.8h-8.869c-.475 0-.86-.386-.86-.86V4.66c0-.476.385-.861.86-.861h8.87c.475 0 .86.385.86.86v2.28c0 .475-.385.86-.86.86M8.006 1.25v22.258c0 .69-.56 1.25-1.25 1.25H3.138c-.69 0-1.25-.56-1.25-1.25V1.25c0-.69.56-1.25 1.25-1.25h3.618c.69 0 1.25.56 1.25 1.25",
    transform: "translate(.312 .346)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.60f1d535ea6ac6a7567c4c15f63cee10.svg";
export { ForwardRef as ReactComponent };